module.exports = __webpack_public_path__ + "img/monitor.bd61e884.svg";